<template>
  <v-container fill-height fluid class="container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6" class="text-center">
        <v-progress-circular v-if="!dataLoaded" :size="70" :width="9" color="primary" indeterminate transition="fade-transition"></v-progress-circular>
        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="qrcodeSuccess">
          <v-list-item>
            <v-list-item-content>
              <div class="primary--text text-h4">Successo</div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>Abbiamo ricevuto il tuo voto, grazie per il tuo supporto.</v-card-text>
        </v-card>
        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="qrcodeError">
          <v-list-item>
            <v-list-item-content>
              <div class="primary--text text-h4">Qualcosa è andato storto</div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>Errore durante la conclusione del voto.</v-card-text>
        </v-card>
        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="qrcodeLeadCreated">
          <v-list-item>
            <v-list-item-content>
              <div class="primary--text text-h4">DATI INSERITI CON SUCCESSO, GRAZIE!</div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>ORA, CONTROLLA LA TUA MAIL PER COMPLETARE LA TUA SCELTA.</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// :key="dataLoaded"

export default {
  watch: {
    options: {
      handler () {
        // this.getClient(this.$route.params.clientId);
      },
      deep: true
    }
  },
  data () {
    return {
      dataLoaded: false,
      qrcodeSuccess: false,
      qrcodeError: false,
      qrcodeLeadCreated: false
    }
  },

  computed: {
    fullName () {
      return (
        this.legalRepresentative.first_name +
          ' ' +
          this.legalRepresentative.last_name || null
      )
    }
  },

  mounted () {
    this.revealMessage(this.$route.params.status)
  },

  methods: {
    revealMessage (status) {
      console.log(status)
      setTimeout(() => {
        if (status === 'success') {
          this.dataLoaded = true
          this.qrcodeSuccess = true
        }
        if (status === 'error') {
          this.dataLoaded = true
          this.qrcodeError = true
        }
        if (status === 'leadCreated') {
          this.dataLoaded = true
          this.qrcodeLeadCreated = true
        }
      }, 2000)
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
